module.exports = __webpack_public_path__ + "static/media/zeze.0211c740.jpeg";